import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Foundation from "./components/Foundation";
import FoundationPageContent from "./components/FoundationPageContent";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import FAQPage from "./components/FAQPage";
import FAQFloatingButton from "./components/FAQFloatingButton";

// Home Page
const Home = ({ isDarkMode, onToggleDarkMode }) => {
  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-[#111A19]' : 'bg-[#E5D9B6]'}`}>
      <Navbar isDarkMode={isDarkMode} onToggleDarkMode={onToggleDarkMode} />
      <main>
        <Hero isDarkMode={isDarkMode} />
        <Foundation isDarkMode={isDarkMode} />
      </main>
      <Footer isDarkMode={isDarkMode} />
      <FAQFloatingButton isDarkMode={isDarkMode} />
    </div>
  );
};

// About Page
const AboutPage = ({ isDarkMode, onToggleDarkMode }) => {
  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-[#111A19]' : 'bg-[#E5D9B6]'}`}>
      <Navbar isDarkMode={isDarkMode} onToggleDarkMode={onToggleDarkMode} />
      <div className="pt-24">
        <About isDarkMode={isDarkMode} />
      </div>
      <Footer isDarkMode={isDarkMode} />
      <FAQFloatingButton isDarkMode={isDarkMode} />
    </div>
  );
};

// Foundation Page (PAAF)
const FoundationPage = ({ isDarkMode, onToggleDarkMode }) => {
  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-[#111A19]' : 'bg-[#E5D9B6]'}`}>
      <Navbar isDarkMode={isDarkMode} onToggleDarkMode={onToggleDarkMode} />
      <div className="pt-24">
        <FoundationPageContent isDarkMode={isDarkMode} />
      </div>
      <Footer isDarkMode={isDarkMode} />
      <FAQFloatingButton isDarkMode={isDarkMode} />
    </div>
  );
};

// Newsletter Page
const NewsletterPage = ({ isDarkMode, onToggleDarkMode }) => {
  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-[#111A19]' : 'bg-[#E5D9B6]'}`}>
      <Navbar isDarkMode={isDarkMode} onToggleDarkMode={onToggleDarkMode} />
      <div className="pt-24">
        <Newsletter isDarkMode={isDarkMode} />
      </div>
      <Footer isDarkMode={isDarkMode} />
      <FAQFloatingButton isDarkMode={isDarkMode} />
    </div>
  );
};

// FAQ Page Wrapper
const FAQPageWrapper = ({ isDarkMode, onToggleDarkMode }) => {
  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-[#111A19]' : 'bg-[#E5D9B6]'}`}>
      <Navbar isDarkMode={isDarkMode} onToggleDarkMode={onToggleDarkMode} />
      <FAQPage isDarkMode={isDarkMode} />
      <Footer isDarkMode={isDarkMode} />
    </div>
  );
};

function App() {
  const [isDarkMode, setIsDarkMode] = useState(true);

  useEffect(() => {
    const savedMode = localStorage.getItem('darkMode');
    if (savedMode !== null) {
      setIsDarkMode(savedMode === 'true');
    }
  }, []);

  const handleToggleDarkMode = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    localStorage.setItem('darkMode', newMode.toString());
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route 
            path="/" 
            element={<Home isDarkMode={isDarkMode} onToggleDarkMode={handleToggleDarkMode} />} 
          />
          <Route 
            path="/about" 
            element={<AboutPage isDarkMode={isDarkMode} onToggleDarkMode={handleToggleDarkMode} />} 
          />
          <Route 
            path="/foundation" 
            element={<FoundationPage isDarkMode={isDarkMode} onToggleDarkMode={handleToggleDarkMode} />} 
          />
          <Route 
            path="/newsletter" 
            element={<NewsletterPage isDarkMode={isDarkMode} onToggleDarkMode={handleToggleDarkMode} />} 
          />
          <Route 
            path="/faq" 
            element={<FAQPageWrapper isDarkMode={isDarkMode} onToggleDarkMode={handleToggleDarkMode} />} 
          />
        </Routes>
      </BrowserRouter>
      <Analytics />
    </div>
  );
}

export default App;
